<c-card *transloco="let t">
  <c-card-body class="px-2" *ngIf="workers">

      <c-row>
        <c-col class="col-lg-6 col-12">
          <h1>{{ t('View Your Workers') }}</h1>

        </c-col>
        <c-col class="col-lg-6 col-12 text-end" *ngIf="!okService.isExtendedPrivacy()">
          <div class="btn-group mb-2 " role="group">
            <button cButton class="btn btn-success text-white" routerLink="/mgmt/worker-add" *ngIf="this.okService.hasMonitorAccess('workers','create')"><i class="fa-solid fa-plus"></i> {{ t('Add a Worker') }}</button>
            <div class="btn-group" *ngIf="okService.isAdmin()">
              <button type="button" class="btn btn-light dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="fa-solid fa-cloud-arrow-up"></i> {{ t('Import/Export Workers') }}
              </button>
              <ul class="dropdown-menu">
                <li *ngIf="okService.isGeotab()"><a class="dropdown-item"  routerLink="/mgmt/workers/workers-import"><i class="fa-solid fa-cloud-arrow-up"></i> {{ t('Import from Geotab') }}</a></li>
                <li><a class="dropdown-item" routerLink="/mgmt/workers/workers-upload"><i class="fa-solid fa-cloud-arrow-up"></i> {{ t('Upload Workers') }}</a></li>
                <li><a class="dropdown-item"  (click)="export()"><i class="fa-solid fa-file-excel"></i> {{ t('Export Report') }}</a></li>
              </ul>
            </div>
            <button cButton class="btn btn-info text-white" routerLink="/mgmt/workers/workers-inactive" *ngIf="okService.hasFeature('license_mgmt')"><i class="fa-solid fa-user-slash"></i>&nbsp;{{ t('Inactive Workers') }}</button>
            <a href="https://okalone.zendesk.com/hc/en-gb/categories/35344596581137-Lone-Workers" class="btn btn-primary" target="_new"><i class="fa fa-question-circle" aria-hidden="true"></i> {{ t('Help') }}</a>
          </div>
        </c-col>
      </c-row>
      <c-row>
        <c-col class="col-12">
          <div class="alert alert-info alert-dismissible fade show" role="alert" *ngIf="!okService.isDismissed('worker_info')">
            <i class="fa-solid fa-circle-info"></i> {{ t('Workers are the staff that need lone worker protection. They use the app to manage their lone working shift, including a check in timer and help button. They activate the app using their unique PIN. Workers can also use a web app, SMS or phone calls to get lone worker monitoring.') }}
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="okService.doDismiss('worker_info')"></button>
          </div>
        </c-col>
      </c-row>
      <c-row class="justify-content-end">

        <c-col class="col-12 col-lg-6">

        <div class="card mb-2" *ngIf="view!='map'">
          <div class="card-header" data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
            <i class="fa-solid fa-chevron-down"></i> {{ t('Filter Workers') }}
          </div>
          <div class="collapse" id="collapseExample">
            <div class="card-body">

              <form cForm >

                <div class="row mb-3">
                  <label  class="col-sm-4 col-form-label text-end" for="search">
                    <b>{{ t('Search') }}</b>
                  </label>
                  <div class="col-sm-6">
                    <input cFormControl id="search" name="search" placeholder="{{ t('Search') }}" [(ngModel)]="search"/>
                  </div>
                </div>



                <div class="row mb-3" *ngIf="!okService.isExtendedPrivacy()">
                  <label  class="col-sm-4 col-form-label text-end" for="monitors">
                    <b>{{ t('Shown Workers') }}</b>
                  </label>
                  <div class="col-sm-6">
                    <select aria-label="Default select example" name="monitors" cSelect [(ngModel)]="monitor">
                      <option value="all">{{ t('All Workers') }}</option>
                      <option value="mine">{{ t('My Monitored') }}</option>
                    </select>
                  </div>
                </div>

                <div class="row mb-3" *ngIf="groups.length> 0 && okService.hasFeature('groups')">
                  <label  class="col-sm-4 col-form-label text-end" for="monitors">
                    <b>{{ t('Worker Group') }}</b>
                  </label>
                  <div class="col-sm-6">
                    <ng-select
                    [items]="groups"
                    name="group"
                    [(ngModel)]="group"
                    bindLabel="name"
                    bindValue="id">
                  </ng-select>
                  </div>
                </div>



                <button cButton class="btn btn-primary" type="submit"  (click)="updateFilter()">
                  <i class="fa-solid fa-magnifying-glass"></i>
                  <span class="d-none d-lg-inline">
                      {{ t('Search') }}
                  </span>
                </button>
                &nbsp;&nbsp;&nbsp;&nbsp;
                  <button cButton class="btn btn-light" type="submit"  (click)="clearFilter()">
                    <i class="fa-solid fa-xmark"></i>
                  <span class="d-none d-lg-inline">
                     {{ t('Clear Filter') }}
                  </span>
                </button>


              </form>

            </div>
          </div>
        </div>
      </c-col>
      <c-col class="col-12 col-lg-6">

      <c-row class="justify-content-end">



        <c-col xs="auto" class="mb-2" *ngIf="pagination.totalPages > 1">
          <c-input-group  class="text-end">
            <span cInputGroupText><i class="fa-solid fa-arrow-down-1-9"></i></span>
            <select aria-label="Default select example" name="page" cSelect (change)="updateFilter()"  [(ngModel)]="pagination.page">
              <option *ngFor="let p of pagination.pageArray" value="{{p}}">{{p}}</option>
            </select>
          </c-input-group>
        </c-col>
        <c-col xs="auto" class="mb-2">
          <c-input-group>
            <span cInputGroupText><svg cIcon class="me-2" name="cil-sort-ascending"></svg></span>
            <select aria-label="Default select example" (change)="updateFilter()" name="sort" cSelect [(ngModel)]="sort">
              <option value="newest">{{ t('Newest') }}</option>
              <option value="oldest">{{ t('Oldest') }}</option>
              <option value="name">{{ t('Name') }}</option>
            </select>
          </c-input-group>
        </c-col>
      </c-row>
        </c-col>
      </c-row>
          <c-row *ngIf="workers">
            <c-col>

              <table
              [hover]="true"
              [responsive]="true"
              [striped]="true"
              cTable
              class="mb-0 border"
              >
                <thead>
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">{{ t('PIN') }}</th>
                    <th scope="col">{{ t('Worker') }}</th>
                    <th scope="col">{{ t('Email') }} / {{ t('Phone') }}</th>
                    <th scope="col">{{ t('Monitors') }}</th>
                    <th scope="col" *ngIf="this.okService.groups && this.okService.groups.length > 0">{{ t('Groups') }}</th>
                    <th scope="col" *ngIf="this.okService.alert_loops && this.okService.alert_loops.length > 0">{{ t('Alert Loops') }}</th>
                    <th scope="col">{{ t('Check In') }}</th>
                    <th scope="col"></th>
                  </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let worker of workers">
                      <td>
                        <button color="info" cButton class="me-1 btn-sm text-white" routerLink="/mgmt/worker/{{worker.id}}"  *ngIf="this.okService.hasMonitorWorkerAccess('workers','view')">
                          <svg cIcon class="me-2" name="cil-pencil"></svg>
                          {{ t('Edit') }}
                        </button>
                      </td>
                      <th scope="row">
                        <div>
                          <span class="badge bg-light text-dark fs-5">{{ u.formatWorkerPin(worker.pin) }}</span>
                        </div>
                      </th>
                      <td>
                        <span><b class="fs-5">{{worker.name}}</b></span>
                      </td>
                      <td>
                        {{worker.email}}
                        <div class="small text-medium-emphasis">
                          <span>{{worker.phone}} <span *ngIf="worker.phone && worker.cell">/</span> {{worker.cell}}</span>
                        </div>
                      </td>
                      <th>
                        <div class="small text-medium-emphasis">
                          <ng-container *ngFor="let monitor_name of worker.monitor_names; let i = index">
                            <span class="pointer" routerLink="/mgmt/monitor/{{worker.monitors[i]}}">{{ monitor_name }}&nbsp;&nbsp;</span>
                          </ng-container>
                        </div>
                      </th>
                      <th *ngIf="this.okService.groups.length > 0">
                        <div class="small text-medium-emphasis">
                          <ng-container *ngFor="let group_name of worker.group_names; let i = index">
                            <span class="pointer" routerLink="/mgmt/group/{{worker.group_ids[i]}}">{{ group_name }}&nbsp;&nbsp;</span>
                          </ng-container>
                        </div>
                      </th>
                      <th *ngIf="this.okService.alert_loops.length > 0">
                        <div class="small text-medium-emphasis">
                          {{worker.alert_loop_name}}
                        </div>
                      </th>
                      <td class="text-center">
                        <span>{{u.minsToString(worker.check_in_freq)}}</span>
                      </td>
                      <td class="text-center">
                        <span *ngIf="worker.geotab_id" class="badge bg-primary text-white fs-6">Geotab</span>
                        <a *ngIf="worker.ehs_insight_id && okService.isEhsInsight()"
                           class="badge bg-success text-white fs-6 text-decoration-none"
                           [href]="okService.ehsInsightUserUrl(worker.ehs_insight_id)"
                           target="_blank" rel="noopener noreferrer">EHS Insight</a>
                        <span *ngIf="worker.zoleo" class="badge bg-success text-white fs-6">ZOLEO</span>
                        <span *ngIf="worker.spot" class="badge bg-warning text-white fs-6">SPOT</span>
                        <span *ngIf="worker.ihelp" class="badge bg-info text-white fs-6">iHelp</span>
                      </td>
                    </tr>
                  </tbody>

              </table>

            </c-col>
          </c-row>
          <c-row class="justify-content-end">

            <c-col xs="auto" class="mt-2 mx-1" *ngIf="workers">
              <p class="mt-1" ><b>{{ t('Total Workers:') }}</b> {{pagination.totalCount}} / {{okService.billing.plan.workers.max}}</p>
            </c-col>

            <c-col xs="auto" class="mt-2" *ngIf="pagination.totalPages>1">
              <c-input-group  class="text-end">
                <span cInputGroupText><i class="fa-solid fa-arrow-down-1-9"></i></span>
                <select aria-label="Default select example" name="page" cSelect (change)="updateFilter()"  [(ngModel)]="pagination.page">
                  <option *ngFor="let p of pagination.pageArray" value="{{p}}">{{p}}</option>
                </select>
              </c-input-group>
            </c-col>

          </c-row>


  </c-card-body>
</c-card>
